
<div>
    <h1>About</h1>
    <p>
        This is the TodoList App v1.0.0. It is a part of Angular crash course
    </p>
</div>